<template>
  <div class="signature-section">
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <div class="signature-box">
          <h6 class="signature-title">
            {{ leftLabel }}
          </h6>
          <div class="signature-line" />
        </div>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <div class="signature-box">
          <h6 class="signature-title">
            {{ displayCompanyLabel }}
          </h6>
          <div class="signature-line" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

export default {
  name: 'DocumentSignature',
  components: {
    BRow,
    BCol,
  },
  props: {
    leftLabel: {
      type: String,
      default: 'Signature du fournisseur',
    },
    companySignatureLabel: {
      type: String,
      default: null,
    },
    company: {
      type: Object,
      default: null,
    },
  },
  computed: {
    displayCompanyLabel() {
      // Priority: prop > company setting > branding > default
      if (this.companySignatureLabel) return this.companySignatureLabel
      if (this.company && this.company.signature_label_company) {
        return this.company.signature_label_company
      }
      const companyName = this.$branding?.company?.name || ''
      const signaturePrefix = this.$branding?.company?.signatureLabel || 'Cachet et signature'
      return `${signaturePrefix} ${companyName}`
    },
  },
}
</script>

<style scoped>
.signature-section {
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px dashed #dee2e6;
}

.signature-box {
  padding: 1rem;
  text-align: center;
}

.signature-title {
  font-size: 0.9rem;
  font-weight: 500;
  color: #495057;
  margin-bottom: 2rem;
}

.signature-line {
  height: 1px;
  background: #212529;
  width: 80%;
  margin: 0 auto;
}

@media print {
  .signature-section {
    page-break-inside: avoid;
  }

  .signature-line {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>
